import React from 'react'
import { FileIconCP } from 'common/components/icons/FileIconCP'
import { SignatureSecurityLevelEnum } from 'modules/document-signature/enums/SignatureSecurityLevelEnum'
import { TooltipCP } from 'common/components/tooltip/TooltipCP'
import { SignatureSecurityLevelUtils } from 'modules/document-signature/utils/SignatureSecurityLevelUtils'
import styled from 'config/theme/styledWithTheme'

type _ScpPropsTP = {
    marginRight?: number,
    marginLeft?: number,
}

interface IAssigneeTableCPProps extends _ScpPropsTP {
    secLevel: SignatureSecurityLevelEnum
    showTooltip: boolean
}

/**
 * COMPONENTE da tabela de signatarios.
 */
export function SignatureSecurityLevelIconCP(props: IAssigneeTableCPProps): JSX.Element | null {

    function getIcon(): JSX.Element {

        let antIconName: 'check' | 'verified' | 'add' | undefined
        switch (props.secLevel) {

            case SignatureSecurityLevelEnum.INVITE:
                antIconName = 'add'
                break

            case SignatureSecurityLevelEnum.SIMPLE_REGISTER:
                antIconName = 'check'
                break

            case SignatureSecurityLevelEnum.FULL_REGISTER:
                antIconName = 'verified'
                break

            default:
                break

        }

        if (!antIconName)
            return <></>

        return <FileIconCP type={antIconName}/>
    }

    return (
        <WrapperSCP
            marginRight={props.marginRight ?? 0}
            marginLeft={props.marginLeft ?? 0}
        >
            {
                !!props.showTooltip
                    ?
                    <TooltipCP
                        text={SignatureSecurityLevelUtils.getSignatureSecurityLevelDescription(SignatureSecurityLevelEnum.SIMPLE_REGISTER)}
                    >
                        { getIcon() }
                    </TooltipCP>
                    :
                    getIcon()
            }
        </WrapperSCP>
    )
}

const WrapperSCP = styled.div<_ScpPropsTP>`
    margin: ${props => `0 ${props.marginRight!}px 0 ${props.marginLeft!}px`};
`
